export default __webpack_public_path__ + "static/media/pool_from_above.6ccfe42a.jpg";